export const ROOM_STATUS = {
  ACTIVE: 0,
  INACTIVE: 1,
  CLOSED: 2,
  PENDING: [3, 4, 5],
  FAIL: 6,
}

export const MAX_ROOM_LIST_LIMIT = 500

export const MAX_DROPDOWN_LIMIT = 200
